import thumbnailImg from 'Static/thumbnails/screenshot--human-body.png';

export default {
  slug: 'human-body',
  title: 'The Human Body',
  seriesNumber: '1',
  published: true,
  thumbnailImg,
  subject: 'Life Sciences',
  graphicFileName: 'Image_THB.png',
  graphicAlt:
    'App screenshot of The Human Body depicting an illustrated digestive system',
  iconFileName: 'Icon_THB.png',
  iconLargeFileName: 'Icon_THB@2x.png',
  iconAlt:
    'App icon for The Human Body depicting an illustrated circulatory system',
  description:
    'Topics covered include the nervous, respiratory, circulatory, skeletal, muscular, and digestive systems.',
  briefDescription: 'Learn about biology, anatomy & more.',
  supportedLanguages: [
    'en',
    'ar',
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'fi',
    'fr',
    'he',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'ms',
    'nb',
    'nl',
    'pl',
    'pt',
    'ro',
    'ru',
    'sv',
    'th',
    'tl',
    'tr',
    'vi',
    'zh-Hant',
    'zh-Hans',
    'bn',
    'ca',
    'et',
    'eu',
    'fa',
    'hi',
    'hr',
    'ht',
    'is',
    'pa',
    'sk',
    'sl',
    'sr',
    'sw',
    'ta',
    'te',
    'uk',
    'ug',
    'ur',
    'uz',
    'af',
    'cy',
    'fl',
    'ga',
    'sq',
    'lv',
    'km',
  ],
  scenes: [
    'BodyScene',
    'Nervous_System',
    'BrainScene',
    'BrainSceneSliderOpen',
    'EyeScene',
    'EarScene',
    'NoseScene',
    'Skeletal_System',
    'SkeletalHandScene',
    'SkeletalHipScene',
    'SkeletalBoneScene',
    'Respiratory_System',
    'LungsScene',
    'LungsSceneSliderOpen',
    'Circulatory_System',
    'HeartScene',
    'HeartSceneSliderOpen',
    'BloodVesselScene',
    'Digestive_System',
    'Digestive_SystemSliderOpen',
    'ToothScene',
    'StomachScene',
    'StomachSceneSliderOpen',
    'LargeIntestineScene',
    'Muscular_System',
    'ArmMusclesScene',
    'LegMusclesScene',
    'Urogenital_System',
    'Urogenital_SystemSliderOpen',
    'Skin',
    'SkinScene',
    'HandScene',
    'Immune_System',
    'Immune_SystemSliderOpen',
    'LymphScene',
    'LymphSceneSliderOpen',
    'AttackSiteScene',
    'CloseupLungScene',
    'IntestineScene',
    'IntestineLiningScene',
  ],
  featuredPrintables: ['thb_inside'],
  printables: [
    'thb_senses',
    'thb_digestive',
    'concept_map',
    'generating_questions',
  ],
  topics: [
    'body_systems',
    'brain_and_senses',
    'healthy_habits',
    'maintaining_balance',
    'response_to_stimuli',
  ],
  deepLinks: {
    'digestive-system': {
      sceneId: 'Digestive_System',
      sceneName: 'BodyScene',
      layers: ['Digestive_System'],
    },
    stomach: 'StomachScene',
    'large-intestine': 'LargeIntestineScene',
    'small-intestine': 'IntestineScene',
    tooth: 'ToothScene',
    'respiratory-system': {
      sceneId: 'Respiratory_System',
      sceneName: 'BodyScene',
      layers: ['Respiratory_System'],
    },
    lungs: 'LungsScene',
    'alveoli-and-bronchioles': 'CloseupLungScene',
    'nervous-system': {
      sceneId: 'Nervous_System',
      sceneName: 'BodyScene',
      layers: ['Nervous_System'],
    },
    brain: 'BrainScene',
    eye: 'EyeScene',
    ear: 'EarScene',
    nose: 'NoseScene',
    'skeletal-system': {
      sceneId: 'Skeletal_System',
      sceneName: 'BodyScene',
      layers: ['Skeletal_System'],
    },
    'bone-marrow': 'SkeletalBoneScene',
    'elbow-and-wrist': 'SkeletalHandScene',
    'circulatory-system': {
      sceneId: 'Circulatory_System',
      sceneName: 'BodyScene',
      layers: ['Circulatory_System'],
    },
    heart: 'HeartScene',
    artery: 'BloodVesselScene',
    'muscular-system': {
      sceneId: 'Muscular_System',
      sceneName: 'BodyScene',
      layers: ['Muscular_System'],
    },
    'immune-system': {
      sceneId: 'Immune_System',
      sceneName: 'BodyScene',
      layers: ['Immune_System'],
    },
    'lymph-vessel': 'AttackSiteScene',
    'lymph-node': 'LymphScene',
    'skin-system': {
      sceneId: 'Skin',
      sceneName: 'BodyScene',
      layers: ['Skin'],
    },
    'hair-follicle': 'SkinScene',
    fingernails: 'HandScene',
  },
  appLinks: {
    appStoreLink:
      'https://apps.apple.com/us/app/the-human-body-by-tinybop/id682046579',
    googlePlayLink:
      'https://play.google.com/store/apps/details?id=com.tinybop.TheHumanBody',
  },
};
